<template>
  <div class="user-promotions">
    <a-row type="flex" justify="space-between">
      <a-col :lg="10" :md="10" :xs="24">
        <h2 class="list-title">
          <a-icon type="folder" class="list-icon" />
          <span>{{ labels.title }}</span>
        </h2>
        <p class="list-subtitle">{{ labels.subtitle }}</p>
      </a-col>
      <a-col :lg="10" :md="10" :xs="24">
        <div class="list-actions" style="text-align: right">
          <a-radio-group v-model="state">
            <a-radio-button value="available"> Disponibles </a-radio-button>
            <a-radio-button value="used"> Usadas </a-radio-button>
            <a-radio-button value="all"> Todas </a-radio-button>
          </a-radio-group>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <StandardTable
          ref="standardTable"
          :loading="loading"
          :columns="columns"
          :locale="locale"
          :handleShowTotal="false"
          :scroll="{ x: true }"
          :rowKey="(record) => record?.code"
          :fetchService="fetchUserPromotions"
        />
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { DATE_FORMAT } from "@/utils/utils";
import accounting from "accounting";
import StandardTable from "@/components/core/table/StandardTable.vue";

export default {
  name: "AssignedLotteries",
  components: {
    StandardTable,
  },
  props: {
    labels: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      activeRow: null,
      state: "available",
    };
  },
  filters: {
    ucwords(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  computed: {
    ...mapState("layout", ["screenWidth"]),
    isMobile() {
      return this.screenWidth < 600;
    },
    locale() {
      return {
        emptyText: this.labels.table.emptyText,
      };
    },
    dateFormat() {
      return "DD/MM/YYYY hh:mm:ss";
    },
    serverDateFormat() {
      return "YYYY-MM-DD HH:mm:ss";
    },
    columns() {
      return [
        {
          title: this.labels.table.columns.code,
          dataIndex: "code",
          key: "code",
          width: "10%",
          hidden: this.isMobile,
          sorter: true,
          customRender: (text) => {
            return text || "";
          },
        },
        {
          title: this.labels.table.columns.type.title,
          dataIndex: "type",
          key: "type",
          width: "14%",
          hidden: this.isMobile,
          customRender: (text) => {
            return this.labels.table.columns.type[text?.toLowerCase()] || "";
          },
        },
        {
          title: this.labels.table.columns.useType.title,
          dataIndex: "use_type",
          key: "use_type",
          width: "10%",
          hidden: this.isMobile,
          customRender: (text) => {
            return this.labels.table.columns.useType[text?.toLowerCase()] || "";
          },
        },
        {
          title: this.labels.table.columns.quantity,
          dataIndex: "quantity",
          key: "quantity",
          width: "10%",
          align: "right",
          hidden: this.isMobile,
          customRender: (text) => {
            return accounting.formatNumber(text || 0, 0, ",", ".");
          },
        },
        {
          title: this.labels.table.columns.startUseAt,
          dataIndex: "start_use_at",
          key: "start_use_at",
          width: "12%",
          hidden: this.isMobile,
          customRender: (text) => {
            return this.$moment(text).format("DD/MM/YYYY hh:mm A");
          },
        },
        {
          title: this.labels.table.columns.expiresAt,
          dataIndex: "expire_at",
          key: "expire_at",
          width: "12%",
          hidden: this.isMobile,
          customRender: (text) => {
            return this.$moment(text).format("DD/MM/YYYY hh:mm A");
          },
        },
        {
          title: this.labels.table.columns.remainingUses,
          dataIndex: "remaining_uses",
          key: "remaining_uses",
          width: "10%",
          align: "center",
          hidden: this.isMobile,
          customRender: (text) => {
            return accounting.formatNumber(text || 0, 0, ",", ".");
          },
        },
        {
          title: this.labels.table.columns.usedAt,
          dataIndex: "used_at",
          key: "used_at",
          width: "12%",
          hidden: this.isMobile,
          customRender: (text) => {
            return text ? this.$moment(text).format("DD/MM/YYYY hh:mm A") : "-";
          },
        },
        {
          title: this.labels.table.columns.state.title,
          dataIndex: "state",
          key: "state",
          width: "10%",
          align: "center",
          hidden: this.isMobile,
          customRender: (text) => {
            return (
              <a-tag color={this.stateColors(text?.toLowerCase()) || "default"}>
                {this.labels.table.columns.state[text?.toLowerCase()]}
              </a-tag>
            );
          },
        },
        {
          title: this.labels.table.columns.promotions,
          dataIndex: "promotions",
          key: "promotions",
          width: "100%",
          hidden: !this.isMobile,
          customRender: (_, record) => {
            // Card item design
            const color =
              this.stateColors(record.state?.toLowerCase()) || "default";
            return (
              <div class="list-item">
                <div class="list-item-head">
                  <div
                    class="list-item-head-header"
                    style={{ borderColor: color }}
                  >
                    <span>
                      {this.$options.filters.ucwords(
                        this.$moment(record.start_use_at).format(
                          DATE_FORMAT.MOMENT_DAY_MONTH
                        )
                      )}
                    </span>
                    <small>
                      {this.$moment(record.start_use_at)
                        .format(DATE_FORMAT.MOMENT_TIME)
                        .toUpperCase()}
                    </small>
                  </div>
                  <div class="list-item-head-content">
                    <div class="list-item-head-content-code">
                      <span>{record.code}</span>
                    </div>
                    <div class="list-item-head-content-state">
                      <a-tag color={color}>
                        {
                          this.labels.table.columns.state[
                            record.state?.toLowerCase()
                          ]
                        }
                      </a-tag>
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
      ].filter((column) => !column.hidden);
    },
  },
  methods: {
    ...mapActions("users", ["fetchPromotions"]),
    stateColors(state) {
      const colors = {
        expired: "orange",
        used: "blue",
        available: "green",
      };
      return colors[state] || "default";
    },
    async fetchUserPromotions(params) {
      if (this.state !== "all") {
        Object.assign(params, { state: this.state });
      }
      return this.fetchPromotions({ userId: this.userId, ...params });
    },
  },
  watch: {
    state(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.$refs.standardTable?.handleSearch("");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.user-promotions {
  .list {
    &-title {
      margin-bottom: 10px;
      .list-icon {
        margin-right: 10px;
      }
    }
    &-subtitle {
      margin-bottom: 10px;
    }
  }

  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        max-width: 22%;
        min-width: 22%;
        border-right: 4px solid color(border);
        .success {
          color: color(success);
        }
        .warning {
          color: color(warning);
        }
        .danger {
          color: color(danger);
        }
        span {
          font-size: 14px;
          font-weight: 600;
        }
        small {
          font-size: 12px;
          font-weight: 400;
          padding-right: 4px;
        }
      }
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 78%;
        min-width: 78%;
        overflow: hidden;
        &-lottery {
          span {
            font-size: 14px;
            font-weight: 600;
            text-overflow: ellipsis;
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .delete-button,
        .edit-button {
          width: 100%;
        }
      }
    }
  }
}
</style>
